import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Icon, Loader, Search } from "semantic-ui-react";
import BCMessage from "../ui/BCMessage";
import BCTable from "../ui/BCTable";
import "../../styles/borrower/home.scss";
import BCDashboard from "../ui/BCDashboard";
import { IErrorResponse, IProxyUser } from "../interfaces/Global";
import BCEmptyState from "../ui/BCEmptyState";
import BWInfolistStyleSwitch from "./BWInfolistStyleSwitch";

interface ITableDataRules {
  field: string;
  rule: string;
}

interface IEmptyState {
  icon?: string;
  text: string;
  context?: string;
}

interface IBWHomeViewAllFrame {
  isGreaterThanTablet: boolean;
  isSidebar: boolean;
  isMessage: boolean;
  setIsMessage: (value: boolean) => React.Dispatch<React.SetStateAction<boolean>>;
  errorResponse: IErrorResponse | undefined; 
  setErrorResponse: (value: boolean) => React.Dispatch<React.SetStateAction<IErrorResponse | undefined>> 
  proxyUser: IProxyUser | undefined;
  isLoading: boolean;
  breadcrumbsCurrent: string;
  formattedDate: any;
  getApiInfoAsync: () => Promise<void>;
  infolistStyleSwitch: boolean;
  cardViewComponents?: JSX.Element; 
  emptyState: IEmptyState;
  tableDataRules?: ITableDataRules[];
  tableSortable: string[] | undefined;
  ellipsis?: boolean;
  ellipsisHandlers?: any;
  handleEditApplication? : (applicationObj: any) => void
  handleCopyApplication?: (applicationObj: any) => void
  handleDrawRequest?: any
}

const BWHomeViewAllFrame = ({...props} : IBWHomeViewAllFrame) => {
  const [isFirstLoad, setIsFirstLoad] = useState(true as boolean);
  const [isCardView, setisCardView] = useState(localStorage.getItem("infolist") === "table" ? false : true);
  
  const history = useHistory();
  const handleError = useCallback(() => {
    history.push("/error");
  }, [history]);

  const handleBackHome = useCallback(() => {
    history.push("/");
  }, [history]);

  const handleInfolistViewType = () => {
    const infolistStyle = isCardView ? "table" : "card";
    localStorage.setItem("infolist", infolistStyle);
    setisCardView(!isCardView);
  };

  const Breadcrumbs = () => {
    return (
      <React.Fragment>
        <div className="breadcrumbs">
          <div className="breadcrumbs-home" onClick={() => handleBackHome()}><Icon name="home" />Home</div>
          <div> &gt; </div>
          <div className="breadcrumbs-current">{props.breadcrumbsCurrent}</div>
        </div>
      </React.Fragment>
    );
  };

  const ViewAllLayout = [
    [
      {
        title: <Breadcrumbs />,
        size: 16,
        headerOptions: [
          <BWInfolistStyleSwitch 
            isGreaterThanTablet={props.isGreaterThanTablet} 
            visible={props.infolistStyleSwitch}
            isCardView={isCardView}
            handleInfolistViewType={handleInfolistViewType} 
          />,
          <Search open={false} onSearchChange={() => console.log("Draw Requests Search")} placeholder="Search" />
        ],
        content: <React.Fragment>
          <BCMessage
            animation={"fly down"}
            duration={750}
            visible={props.isMessage}
            transitionOnMount
            styles="full-width"
            onDismiss={() => props.setIsMessage(false)}
            errorResponse={props.errorResponse}
          />
          {props.formattedDate.length > 0 ? <React.Fragment>
            {!isCardView ? <div>
              <BCTable 
                data={props.formattedDate}
                dataRules={props.tableDataRules}
                selectable
                ellipsis
                ellipsisHandlers={props.ellipsisHandlers}
                editMode={true}
                handleApplication={props.handleEditApplication}
                handleCopyApplication={props.handleCopyApplication}
                handleDrawRequest={props.handleDrawRequest}
                overflowX
                overflowY
                dataSingleLine
                sortable={props.tableSortable}
                pagination={17}
              /></div>
            : <React.Fragment>{props.cardViewComponents}</React.Fragment>}
            </React.Fragment>
            : <BCEmptyState
              emptyStateClass="home-content-empty-state"
              icon={props.emptyState.icon}
              text={props.emptyState.text}
              content={props.emptyState.context}
            />
          }
        </React.Fragment>
      }
    ]
  ];
    
  useEffect(() => {
    if (isFirstLoad) {
      props.getApiInfoAsync();
    }
  }, [props.setIsMessage, props.setErrorResponse, handleError, props.proxyUser, isFirstLoad]);

  useEffect(() => {
    setIsFirstLoad(false);
  }, []);

    return (
      <div className={(props.isGreaterThanTablet && props.isSidebar) ? "landing-page hide-sidebar" : "landing-page sidebar"}>
        {props.isLoading ? <Loader active inline="centered" size="big" /> : <React.Fragment>
          <BCDashboard
            DashboardLayout={ViewAllLayout}
            dashboardHeaderOptions={true}
          />
        </React.Fragment>}
      </div>
    );
  };
  
export default BWHomeViewAllFrame;